// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"bf2e9b17","533":"15c8bd63","856":"2f0c3d05","951":"bbda5e59"}[chunkId] + ".chunk.css";
};